/** Comprador seleccionado en modo Distribuidor para revisar su cartera en este servidor. */

const OWNER_KEY = "visor:distributor_review_owner_id";
const BUYER_KEY = "visor:distributor_review_buyer_id";
const LABEL_KEY = "visor:distributor_review_buyer_label";

export function getDistributorReviewOwnerId() {
  try {
    return localStorage.getItem(OWNER_KEY) || "";
  } catch {
    return "";
  }
}

export function getDistributorReviewBuyerId() {
  try {
    return localStorage.getItem(BUYER_KEY) || "";
  } catch {
    return "";
  }
}

export function getDistributorReviewBuyerLabel() {
  try {
    return localStorage.getItem(LABEL_KEY) || "";
  } catch {
    return "";
  }
}

export function setDistributorReview({ buyerId, ownerUserId, label }) {
  try {
    if (ownerUserId && buyerId) {
      localStorage.setItem(OWNER_KEY, ownerUserId);
      localStorage.setItem(BUYER_KEY, buyerId);
      localStorage.setItem(LABEL_KEY, label || "");
    } else {
      localStorage.removeItem(OWNER_KEY);
      localStorage.removeItem(BUYER_KEY);
      localStorage.removeItem(LABEL_KEY);
    }
    window.dispatchEvent(new CustomEvent("visor:distributor-review-changed"));
  } catch {
    /* ignore */
  }
}

export function clearDistributorReview() {
  setDistributorReview({ buyerId: "", ownerUserId: "", label: "" });
}

export function isDistributorReviewActive() {
  return Boolean(getDistributorReviewOwnerId());
}
